export default "__VITE_ASSET__799a4bfb__"